import React from "react";

const BenefitsAdaIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="17"
    height="20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#benefits-ada-icon-clip)">
      <path
        opacity="0.972"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.79497 0.020874C6.89527 0.0613092 7.50895 0.626163 7.63598 1.71543C7.46472 2.93263 6.76736 3.47656 5.54393 3.34723C4.73974 3.10075 4.3074 2.55682 4.24686 1.71543C4.33933 0.752497 4.85539 0.187644 5.79497 0.020874Z"
        fill="#5B5A54"
      />
      <path
        opacity="0.975"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.62761 3.91215C5.96263 3.9052 6.29736 3.91215 6.63179 3.93307C7.21003 4.1196 7.52384 4.51709 7.57321 5.12554C7.59413 5.83671 7.60112 6.54801 7.59413 7.25943C8.91915 7.25244 10.2441 7.25943 11.569 7.28035C12.2324 7.45654 12.4346 7.86796 12.1757 8.51466C12.0169 8.73704 11.8007 8.85558 11.5272 8.87031C10.2341 8.90499 8.94401 8.89801 7.65689 8.84939C7.60924 9.02336 7.58832 9.20466 7.59413 9.39332C7.60807 9.56069 7.62204 9.72805 7.63597 9.89541C9.29392 9.93002 10.9536 9.95094 12.6151 9.95817C12.8728 9.99286 13.0611 10.1254 13.1799 10.3557C14.3096 12.1688 15.4393 13.9819 16.569 15.795C16.7902 16.4755 16.56 16.9288 15.8787 17.1548C15.5813 17.2165 15.3163 17.1537 15.0837 16.9665C14.1898 15.6473 13.3042 14.3223 12.4268 12.9916C12.3622 12.9131 12.2855 12.8503 12.1966 12.8034C10.0652 12.7481 7.93129 12.7202 5.79497 12.7197C5.1166 12.5853 4.74702 12.1738 4.68618 11.4854C4.65828 9.36541 4.65828 7.2455 4.68618 5.12554C4.74028 4.51357 5.05409 4.10909 5.62761 3.91215Z"
        fill="#5B5A54"
      />
      <path
        opacity="0.961"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.07532 7.84521C3.7895 7.8686 4.03356 8.21727 3.80753 8.89124C1.70406 10.624 1.09038 12.7857 1.96653 15.3766C2.8082 17.2204 4.2308 18.3083 6.23431 18.6402C8.41599 18.8434 10.1454 18.0624 11.4226 16.2971C11.5918 15.9608 11.7941 15.647 12.0293 15.3557C12.588 15.1333 12.9366 15.3146 13.0753 15.8996C13.0118 16.1733 12.9072 16.4313 12.7615 16.6737C11.0444 19.3065 8.62461 20.3734 5.5021 19.8745C2.78942 19.1702 1.08088 17.4617 0.376572 14.749C-0.104829 12.0785 0.669229 9.85396 2.69875 8.07534C2.81435 7.97601 2.93988 7.89927 3.07532 7.84521Z"
        fill="#5B5A54"
      />
    </g>
    <defs>
      <clipPath id="benefits-ada-icon-clip">
        <rect width="16.6527" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BenefitsAdaIcon;
